/**
 * ADRESA Z JEDNOHO RADKU TEXTU — jedno pravidlo pro cely REOS.
 *
 * Pruvodce „Nová" i nazev zakazky nesou adresu jako JEDEN retezec
 * („Topolová 912, Milovice"). Tohle je jediny vyklad toho retezce: prvni cast
 * = ulice s cislem, druha = obec. Nic se nedomysli — rozpad na RÚIAN dela az
 * prověření.
 *
 * ZADNE ZAVISLOSTI: modul je cista funkce, aby ho vedle administrace mohl
 * pouzit i migracni skript `ops/scripts/pil1-zakazky-bez-nemovitosti.ts`
 * (zakazky bez nemovitosti dohledava z tehoz textu). Dve kopie pravidla by
 * znamenaly, ze skript zalozi JINOU adresu, nez by zalozil pruvodce, a dedupe
 * `normalized_key` by je nespojil (CLAUDE.md §8.2).
 */

export interface AddressFromQuery {
  readonly street: string;
  readonly locality?: string;
  readonly location?: { readonly lat: number; readonly lng: number };
}

export function propertyAddressOf(
  addressQuery: string,
  location: { readonly lat: number; readonly lon: number } | null | undefined,
): AddressFromQuery {
  const [street = addressQuery.trim(), locality] = addressQuery.split(',').map((part) => part.trim());
  return {
    street: street.slice(0, 200),
    ...(locality === undefined || locality === '' ? {} : { locality: locality.slice(0, 120) }),
    ...(location == null ? {} : { location: { lat: location.lat, lng: location.lon } }),
  };
}
